export const OPERATORS = {
  EQ: 'eq',
  LT: 'lt',
  GT: 'gt',
  LTE: 'lte',
  GTE: 'gte',
  LIKE: 'like',
}
